<template>
  <AppSection id="scope-dashboard" :title="$getConst.pages.policies.policies_page_title" type="section">
    <b-row class="justify-content-center">
      <template v-for="option in options">
        <b-col
          xl="3" lg="4" md="4" sm="6"
          class="pb-4"
        >
          <AppPageOptionBox
            :icon="option.icon"
            :text="option.text"
            @onClick="goToRoute(option.routeName)"
          />
        </b-col>
      </template>
    </b-row>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppPageOptionBox from "../../../../components/common/utils/AppPageOptionBox";
  import policiesSettings from "./policies";
  export default {
    name: "index",
    components: {AppPageOptionBox, AppSpinner, AppSection},
    data() {
      return {
        options: policiesSettings
      }
    },
    props: {
      scope_id: null,
      scope_name: null
    },
    methods: {
      goToRoute(routeName) {
        this.$router.push({name: routeName});
      }
    }
  }
</script>

<style scoped>

</style>
